export class AddAddressModel {
    id: string;
    consumerId: string;
    address: string;
    postalCode: number;
    city: string;
    locationType: string;
    default: true;
    type: string;
    addressLabel: string;
    isDefault: boolean;
    state: string;
    country: string;
}